import { createAction } from "redux-actions";

export enum LoadAction {
  LOAD_EXPORTED_SCORM_PACKAGES_AMOUNT = "LOAD_EXPORTED_SCORM_PACKAGES_AMOUNT",
  HANDLE_LOAD_EXPORTED_SCORM_PACKAGES_AMOUNT = "HANDLE_LOAD_EXPORTED_SCORM_PACKAGES_AMOUNT",
}

export const loadExportedSCORMPackagesAmount = createAction<void>(LoadAction.LOAD_EXPORTED_SCORM_PACKAGES_AMOUNT);

export const handleLoadExportedSCORMPackagesAmount = createAction<string>(
  LoadAction.HANDLE_LOAD_EXPORTED_SCORM_PACKAGES_AMOUNT
);
